import React from "react";
import "../../../assests/css/students/TopBlogCard.css";
import { useNavigate } from "react-router-dom";


const TopBlogCard = ({blogs}) => {
    const navigate = useNavigate();
  return (
    <div className="tbc-card">
      <span className="tbc-tag">Campus Life</span>

      <img
        src="https://media.istockphoto.com/id/475315086/photo/yale-university-buildings.jpg?s=612x612&w=0&k=20&c=FygHbo4S-clsnKNqz11PXtoISlRFEFbLGYrzQrb9_gY="
        alt="Campus"
        className="tbc-image"
      />

      <h3 className="tbc-title">A Day in the Life of Our Campus</h3>
      {/* <h3 className="tbc-title">{blogs[0].title}</h3> */}

      <p className="tbc-desc">
        From morning lectures to evening activities, take a beautiful journey
        through a typical day at our vibrant college campus.
      </p>

      <div className="tbc-meta">April 12, 2024 | By Admin</div>

      {/* <button className="tbc-btn" onClick={() => navigate("/blogsdetail")}>Read Full Story</button> */}
    </div>
  );
};

export default TopBlogCard;
